import ERP from "../ERP.mjs";
import Schema from "../Schema.mjs";

export default {

    async criaFollowUp(followUpValores = {}){

        let followUp;

        try{

            followUp = await ERP.postOne(Schema.PEDIDO_DE_COMPRA_FOLLOWUPS, followUpValores);
            if(followUp.status != 200){
                throw followUp;
            }

            console.log(followUp);

        }catch(e){

            console.log(e);
            return followUp;

        }

        return followUp;

    },

}